import { Api } from '@axiom/ui';
import type { Candidate, CandidateWhiteboard } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

class TalentWhiteboardApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readCandidateNotes(candidateId: CandidateWhiteboard['candidateId']) {
    return super.read<{ data: CandidateWhiteboard }>({
      endpoint: `/candidates/${candidateId}/whiteboard`,
      method: 'GET',
    });
  }

  async updateCandidateNotes(body: CandidateWhiteboard) {
    return super.write<{ data: CandidateWhiteboard }>({
      endpoint: `/candidates/${body.candidateId}/whiteboard`,
      body,
      method: 'PUT',
    });
  }

  async refreshNotes(candidateId: CandidateWhiteboard['candidateId']) {
    return super.invalidate(`/candidates/${candidateId}/whiteboard`);
  }
}

export const TalentWhiteboardApi = new TalentWhiteboardApiClass();

const api = new LegacyApiHelper('talent-whiteboard');

export const getCandidateWhiteboard = async (id: Candidate['id']) => {
  const response = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/candidates/${id}/whiteboard`
  );
  return { data: response.data };
};

export const putCandidateWhiteboard = async (
  id: Candidate['id'],
  payload: Partial<CandidateWhiteboard> = { body: '' }
) => {
  const response = await TalentWhiteboardApi.write<{
    data: CandidateWhiteboard;
  }>({
    endpoint: `/candidates/${id}/whiteboard`,
    body: payload,
    method: 'PUT',
  });
  return { data: response.data };
};
